export enum EKwikUIProgressSegmentedSize {
  XS = "xs",
  S = "s",
  M = "m",
  L = "l",
  XL = "xl"
}
export const VKwikUIProgressSegmentedSize = [
  EKwikUIProgressSegmentedSize.XS,
  EKwikUIProgressSegmentedSize.S,
  EKwikUIProgressSegmentedSize.M,
  EKwikUIProgressSegmentedSize.L,
  EKwikUIProgressSegmentedSize.XL
] as const;

export type TKwikUIProgressSegmentedSize =
  (typeof VKwikUIProgressSegmentedSize)[number];
